export function storagePercentToColor(percent) {
  var color = "success";
  if (percent >= 75 && percent <= 89) {
    color = 'warning';
  } else if (percent >= 90 && percent <= 100) {
    color = 'error';
  }
  return color;
}